import { FieldNames } from 'Constants/FieldNames'

export const MAX_COUNT_DAYS_BG = 1129
export const MAX_COUNT_DAYS_COMMERCIAL_BG = 2610
export const MAX_COUNT_DAYS_WARRANTY_BG = 1861
export const MAX_CHECKING_ACCOUNTS = 3
export const ACCEPTED_FILES_DOCUMENTS =
	'.gif,.jpg,.jpeg,.rtf,.png,.pdf,.doc,.docx,.xls,.xlsx,.xml,.zip,.rar'
export const MAX_SIZE_DOCUMENTS = 10 * 1024 * 1024
export const AWAITING_DEFAULT_STATUS = '1'
export const SEGMENT_INCREASED = 'MMB'
export const MIN_AMOUNT = 10000
export const MAX_AMOUNT = 200000
export const MIN_AMOUNT_NOVA = 1000000.0
export const TIMER_CHANGE_FIELDS = 2000
export const TIMER_CHANGE_AWAITING = 3000
export const START_DATE_MAX_HOUR = 14

export const CALC_COMMISSION_FIELDS = [FieldNames.STARTDATE, FieldNames.ENDDATE, FieldNames.AMOUNT]

export enum AstSigned {
	SIGNED = 0,
	WAITING = 1,
}

export enum RejectDescr {
	NPA = 'Нет доступных продуктов.',
}
export const ValidateMessages = {
	[RejectDescr.NPA]: 'На указанный срок действия и/или сумму выпуск гарантии невозможен',
}
